<template>
  <div class="messages-container">
    <virtual-list class="messages" :size="40" :remain="8">
      <div v-for="message in sortedMessages" :key="message.id" class="message" :class="{ my: isMyMessage(message) }">
        <a
          v-if="showCardId"
          class="card-link"
          :class="{ contrast: isMyMessage(message) }"
          href="#"
          @click.prevent="editCard(message.card_id)"
          >{{ message.card_id }}&nbsp;</a
        >
        <span class="sender">{{ toHumanUserName(message.user_id) }}</span>
        <span class="timestamp">{{ " " + toHumanTime(message.moment) }}</span>
        <br />
        <span class="text" v-html="textToHtml(message.text)"></span>
      </div>
    </virtual-list>
  </div>
</template>
<script>
import { mapState } from "vuex";

import { sortByDateDescending } from "@/common/utils.sort";
import { EDIT_CARD } from "@/store/actions.type";

import virtualList from "vue-virtual-scroll-list";
import cache from "../../../store/cache";

export default {
  name: "CardChatMessages",
  props: ["messages", "showCardId"],
  components: { virtualList },
  computed: {
    ...mapState("users", { user: "active" }),
    sortedMessages() {
      if (!this.messages) return [];

      return sortByDateDescending(this.messages);
    }
  },
  data() {
    return {};
  },
  methods: {
    editCard(card_id) {
      this.$store.dispatch(EDIT_CARD, cache.cards.byId(card_id));
    },
    textToHtml(text) {
      if (!text) {
        return text;
      }

      return this.linkify(text);
    },
    linkify(inputText) {
      var replacedText, replacePattern1, replacePattern2, replacePattern3;

      //URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a class="link" href="$1" target="_blank">$1</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a class="link" href="http://$2" target="_blank">$2</a>');

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
      replacedText = replacedText.replace(replacePattern3, '<a class="link" href="mailto:$1">$1</a>');

      return replacedText;
    },
    toHumanUserName(user_id) {
      if (!user_id) return user_id;

      const user = cache.users.byId(user_id);
      if (user) {
        return user.name;
      }

      return user_id;
    },
    toHumanTime(time) {
      if (!time) return time;

      return time.format("DD.MM.YY HH:mm:ss");
    },
    isMyMessage(message) {
      return message.user_id == this.user.id;
    }
  }
};
</script>
<style lang="postcss">
.messages-container {
  .messages {
    height: 100% !important;
    .message {
      padding: 0.5em;
      margin: 0.5em;
      border-radius: 8px;
      background: var(--bg-chat-message);
      margin-right: 40px;
      word-wrap: break-word;

      .sender {
        font-weight: bold;
      }

      .timestamp {
        font-size: 0.8em;
      }

      .link {
        color: var(--color-text);
      }
    }

    .my {
      background: var(--bg-chat-message-my);
      margin-right: 0px;
      margin-left: 40px;
    }
  }
}
</style>
